/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModel } from '../../models/user-model';

export interface OdataUserCount$Plain$Params {
}

export function odataUserCount$Plain(http: HttpClient, rootUrl: string, params?: OdataUserCount$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
  const rb = new RequestBuilder(rootUrl, odataUserCount$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserModel>>;
    })
  );
}

odataUserCount$Plain.PATH = '/odata/user/$count';
